// extracted by mini-css-extract-plugin
export default {"root":"search_highlights-module___root___ee560b00","highlightsLayout":"search_highlights-module___highlightsLayout___d88d1071"};